import { Briefcase, Building2, Package, Plane, User, Users } from "lucide-react";
import { useLang } from "../i18n";
import { Eyebrow, Reveal } from "./Reveal";

const ICONS = [Users, User, Plane, Building2, Briefcase, Package];

export default function Services() {
  const { t } = useLang();
  return (
    <section id="services" className="bg-night py-24 lg:py-28">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
        <Reveal>
          <Eyebrow>{t.services.eyebrow}</Eyebrow>
          <h2
            data-testid="services-heading"
            className="mt-5 max-w-2xl font-serif text-4xl text-white sm:text-5xl"
          >
            {t.services.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={s.t} delay={(i % 3) * 0.08} className="h-full">
                <div
                  data-testid={`service-card-${i + 1}`}
                  className="h-full rounded-2xl border border-white/5 bg-coal p-8 transition-colors hover:border-gold/30"
                >
                  <div className="flex items-start justify-between">
                    <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-gold/40 text-gold">
                      <Icon className="h-5 w-5" />
                    </span>
                    <span className="price-oldstyle font-serif text-3xl text-gold/50">
                      0{i + 1}
                    </span>
                  </div>
                  <h3 className="mt-7 font-serif text-2xl text-white">{s.t}</h3>
                  <p className="mt-2 text-sm text-white/60">{s.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
